<template>
  <div class="layout-row item">
    <div class="number">{{ index + 1 }}</div>
    <div class="layout-col" style="flex: 1">
      <div class="layout-row title f-j-b">
        <div class="layout-col" style="height: 1.75rem" @click="user">
          <div class="name">{{ item.nickname }}</div>
          <div class="time">{{ item.location }} {{ item.publish_time }}</div>
        </div>
      </div>
      <slot />
      <Kcontent
        v-if="item.content"
        @tap="replyTap"
        :row="5"
        :text="item.content"
      />
      <div
        class="layout-row f-c"
        v-if="item.img_url"
        @click="showImg(item.img_url)"
      >
        <img
          style="width: 15px; height: 12px; margin-right: 5px"
          src="../../image/imghidden.png"
          alt=""
        />
        <span style="color: #f6a54e; font-size: 0.7rem">查看原图</span>
      </div>
      <set
        v-if="$route.query.is_message != 1"
        :data="{ type: 1 }"
        :item="item"
      />
    </div>
  </div>
</template>

<script>
import set from "./set";
import Kcontent from "./content";
export default {
  components: {
    set,
    Kcontent,
  },
  props: ["item", "index"],
  created() {
    this.item.img_url = img_b(this.item.img_url);
  },
  methods: {
    user() {
      this.$router.push({
        path: `/h5/userMy/${this.item.user_id}`,
        query: {
          user_id: this.item.user_id,
        },
      });
    },
    showImg(src) {
      vant.ImagePreview([src]);
    },
    replyTap() {
      this.$store.commit("setCommentSetShow", {
        show: true,
        update: 0,
        data: this.item,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  padding: 0.5rem 0.5rem 0.5rem 0;
  // border-bottom: 1px solid #f1e6de;
  .comment-but {
    justify-content: flex-end;
    padding-top: 1rem;
    span {
      margin-left: 0.75rem;
    }
  }
  .number {
    margin-right: 0.15rem;
    margin-left: -2px;
    width: 1.05rem;
    text-align: center;
    height: 0.65rem;
    // font-weight: bold;
    background: #fae9d3;
    border-radius: 0px 0.35rem 0.3rem 0px;
    font-size: 0.5rem;
    color: #e78d5b;
    flex-shrink: 0;
  }
  .title {
    .name {
      font-size: 0.7rem;
      color: #2d549a;
    }
    .time {
      font-size: 0.55rem;
      color: #aaaaaa;
    }
  }
  .text {
    margin-top: 0.55rem;
    font-size: 0.75rem;
    font-weight: 500;
    color: #333333;
    line-height: 1.15rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/comment/ItemReply.vue